var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"qrCodeUrl",style:({width: _vm.qrwidth+'px',height: _vm.qrheight+'px'})})
}
var staticRenderFns = []

export { render, staticRenderFns }